import { render, staticRenderFns } from "./TaskRowAttribute.vue?vue&type=template&id=05d804c0&"
import script from "./TaskRowAttribute.vue?vue&type=script&lang=js&"
export * from "./TaskRowAttribute.vue?vue&type=script&lang=js&"
import style0 from "./TaskRowAttribute.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports